import { Field, FieldProps } from 'formik';
import Select, { ActionMeta } from 'react-select';
import { MultiselectCustomStyles } from '$/core/styles';
import { IIdentifiable } from '$/core/models';
import InputBlock from '../inputBlock';
import * as Bixby from '$/core';

interface IReactMultiselectProps extends FieldProps {
  isEditing: boolean;
  options: IIdentifiable[];
}

const ReactMultiselect = ({ field, form, isEditing, options }: IReactMultiselectProps) => {
  const onChange = (newOptions: ReadonlyArray<IIdentifiable>, _actionMeta: ActionMeta<any>) => {
    form.setFieldValue(field.name, newOptions);
  };

  const getValue = () => {
    return field.value;
  };

  return (
    <Select
      isMulti
      onChange={onChange}
      value={getValue()}
      options={options}
      styles={MultiselectCustomStyles}
      isDisabled={!isEditing}
      getOptionLabel={option => option.name}
      getOptionValue={option => option.id}
    />
  );
};

interface IBixReadonlyMultiselectProps {
  fieldName: string;
  isEditing: boolean;
  options: IIdentifiable[];
  sort: boolean;
  title: string;
}

const BixReadonlyMultiselect = ({ fieldName, isEditing, options, sort, title }: IBixReadonlyMultiselectProps) => {
  if (sort === true) {
    options = Bixby.Utils.orderBy(options, _ => _.label);
  }

  return (
    <InputBlock title={title}>
      <Field
        component={ReactMultiselect}
        disabled={!isEditing}
        name={fieldName}
        options={options}
        isEditing={isEditing}></Field>
    </InputBlock>
  );
};

export default BixReadonlyMultiselect;
